export default class EmitterUtils {
    /* Access modifiers in JavaScript
    public (used by default) - function is defined without prefix (e.g., function_name), accessible from everywhere
    protected - function is defined with prefix "_" (e.g., _function_name), accessible within the class and its subclasses
    private - function is defined with prefix "#" (e.g., #function_name), only accessible within the class itself
     */

    /*
    No Enum support in JavaScript. TypeScript supports it, but in JavaScript the best approximation is a JSON.
     */
    static TimeUnits = {
        SECONDS: "seconds",
        MILLISECONDS: "milliseconds"
    }

    /**
     *
     * @param date to add time to
     * @param intervalString interval unit (milliseconds, seconds...)
     * @param amount either int or double
     * @returns {Date} new date with added time.
     */
    static addToDate(date, intervalString, amount) {
        let interval;
        switch (intervalString) {
            case EmitterUtils.TimeUnits.SECONDS:
                interval = 1000;
                break;
            case EmitterUtils.TimeUnits.MILLISECONDS:
            default:
                interval = 1;
                break;
        }

        return new Date(date.getTime() + interval * amount);
    }
}

